import { Component, OnDestroy, OnInit, RendererFactory2, ViewEncapsulation, Renderer2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { LogoTypeEnum, RecipientRole, Template } from 'app/main/pages/edit-template/edit-template.dto';
import { setOrgnizationData, setRecipientData } from 'app/global/get-recipient-data';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { GlobalService } from 'app/global/global.service';
import { DomHelperService } from 'app/global/dom-helper.service';
import { TranslocoService } from '@jsverse/transloco';
import { TranslationsHelperService } from 'translations.helper.service';
import { RefreshFileService } from 'app/main/signing-pages/helpers/refresh-file.service';
import { RefreshImageService } from 'app/global/refresh-image.service';
import { AuthenticationTypeEnum, SigningStatusEnum } from 'app/main/signing-pages/enums/enum';
import { OnlineContractFacade } from './store/facade/online-contract.facade';
import { EID_NOT_COMPLETED_CODE } from './store/state/online-contract.state';
import { Observable, takeUntil, Subject, Subscription, take, of, delay, debounceTime, distinctUntilChanged, filter, tap, skipWhile, timer, startWith } from 'rxjs';
import { FormArray, FormBuilder, FormGroup, AbstractControl } from '@angular/forms';
import { HelperService } from 'app/main/pages/edit-template/helper.service';
import { StepEnum, StepNumberEnum } from 'app/main/pages/edit-template/eform-steps.dto';
import { EformStepsService } from 'app/main/pages/edit-template/eform-steps/eform-steps.service';
import { fieldsValidation } from 'app/global/fieldvalidation';
import { getRoleValidationBeforeSign, initValidationForRecipientTabs } from 'app/global/get-form-validation-errors';
import { SigningPageEventService } from 'app/main/signing-pages/signing-page/signing-page-event.service';
import { RoleDetail } from 'app/main/signing-pages/signing-page/signing-page.dto';
import { updateOrganizationField, updatePersonField } from 'app/global/synchronize';
import { OnlineContractEventEmitterService } from './online-contract-event-emitter.service';
import { Field } from 'app/interfaces/fields';
import { ParseNamePipe } from 'app/pipes/parse-name.pipe';
import { AgreeTermsAndConditionsComponent } from '../agree-terms-and-conditions/agree-terms-and-conditions.component';
import { BankIdService, BankIdResponse } from 'app/bankid/bankid.service';
import Personnummer from 'personnummer';
import { CollectResponseV6 } from 'app/bankid';
import { BankidQrCodeModalComponent } from 'app/main/pages/general-modals/bankid-qr-code-modal/bankid-qr-code-modal.component';
import { EditorEmitterService } from 'app/main/pages/events/editor-emitter.service';
import { DeletedAttachment } from 'app/main/pages/events/editor-emitter.dto';
import { HttpActionState } from 'app/main/pages/users/userslisting/store/users-listing.reducers';
import { SharedStoreFacade } from 'app/main/shared/shared/store/shared-store.facade';
import { EFormBrandingService } from 'app/main/pages/edit-template/settings-tab/eform-branding/eform-branding.service';
import { SignDocumentModalComponent } from 'app/main/signing-pages/sign-document-modal/sign-document-modal.component';
import { ToastrService } from 'ngx-toastr';
import { InvitationThroughEnum } from 'app/main/pages/general-editor-tabs/recipients-tab/recipient-tab.dto';
import { CriiptioBankService } from 'app/bankid/criiptio-bank.service';
import {CreditSafeService} from "../add-ons/credit-safe/credit-safe.service";
import { RecipientModalComponent } from 'app/main/pages/general-modals/recipient-modal/recipient-modal.component';
import { InvitationTypePipe } from 'app/pipes/invitation-type.pipe';
import { SamsungBrowserInstructionsModalComponent } from 'app/main/pages/general-modals/samsung-browser-instructions-modal/samsung-browser-instructions-modal.component';
import { TokenHelperService } from 'app/global/token-helper.service';

@Component({
  selector: 'app-online-contract',
  templateUrl: './online-contract.component.html',
  styleUrl: './online-contract.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class OnlineContractComponent implements OnInit, OnDestroy {
  constructor(
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private modalService: NgbModal,
    private _coreSidebarService: CoreSidebarService,
    private deviceService: DeviceDetectorService,
    private globalService: GlobalService,
    rendererFactory: RendererFactory2,
    private domHelperService: DomHelperService,
    private _translocoService: TranslocoService,
    private _translationsHelperService: TranslationsHelperService,
    private _refreshFileService: RefreshFileService,
    private refreshImageService: RefreshImageService,
    private $onlineContractFacade: OnlineContractFacade,
    private helperService: HelperService,
    private formBuilder: FormBuilder,
    private eformStepsService: EformStepsService,
    private signingPageEvent: SigningPageEventService,
    private onlineContractEventEmitterService: OnlineContractEventEmitterService,
    private bankIdService: BankIdService,
    private editorEmitter: EditorEmitterService,
    private _sharedStoreFacade$: SharedStoreFacade,
    private eFormBrandingService: EFormBrandingService,
    private toastr: ToastrService,
    private criiptioBankService:CriiptioBankService,
    private creditSafeService: CreditSafeService,
    private tokenHelperService: TokenHelperService
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }
  private renderer: Renderer2;
  public id: number = 0;
  public externalSender = null;
  public templateContent: SafeHtml | string = '';
  public roleDetail: RoleDetail = null;
  public authenticationTypeEnum = AuthenticationTypeEnum;
  public invitationThroughEnum = InvitationThroughEnum;
  public signingStatusEnum = SigningStatusEnum;
  public onlineContractLoading: boolean = true;
  private onlineContractForm: Observable<Template> = this.$onlineContractFacade.getOnlineContract$;
  private signOnlineContractRequestState: Observable<HttpActionState> = this.$onlineContractFacade.signOnlineContractRequestState$;
  private signOnlineContractErrorCode$: Observable<string | null> = this.$onlineContractFacade.signOnlineContractErrorCode$;
  private sendOnlineContractInvitationRequestState: Observable<HttpActionState> = this.$onlineContractFacade.selectSendOnlineInvitationRequestState$;
  private visitedRoles$: Observable<RecipientRole[]> = this.$onlineContractFacade.visitedRoles$;
  private destroyed = new Subject<void>();
  public EForm: FormGroup;
  public currentStep: string = StepEnum.ActiveRoleField;
  public stepEnum = StepEnum;
  private stepNumberEnum = StepNumberEnum;
  private activeStep = 1;
  public timeOutSubscription: Subscription;
  public agreeTermsAndCondition: boolean = false;
  public isMobile: boolean = false;
  public orderRef: string = '';
  public template: Template;
  public third_party_auth_response = null;
  public eid_reference: string | null = null;
  public bankidLoader: boolean = false;
  private deletedAttachment: DeletedAttachment[] = [];
  public branding_logo: string = '';
  public logoTypeEnum = LogoTypeEnum;

  public showCreditSafe: boolean = false;
  public templateKey: string = '';
  public creditSafeApproved: boolean = false;
  public creditSafePersonalNumber = '';
  public creditSafeOrganizationNumber = '';
  public currentRecipientIndex: number = 0;
  private translation:string = '';
  private translationParams = {};
  public isSignatorySelected: boolean = false;
  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobile();
    this.id = Number(this.route.snapshot.paramMap.get('id'));
    this.externalSender = this.route.snapshot.paramMap.get('user_id') || null;
    this.tokenHelperService.saveSigningPageToken(this.route.snapshot.paramMap.get('token'), String(this.id));
    this.$onlineContractFacade.getOnlineContract(Number(this.id), this.externalSender);
    this.onlineContractForm.pipe(
      filter(x => x !== null),
      tap(template => {
        if (template.status === 0) {
          this.globalService.toastrError(this._translocoService.translate("Toaster error message for online contract (EForm - section) - The template is not available"));
        }
      }),
      skipWhile(template => template.status === 0),
      take(1)
    ).subscribe(template => {
      this.template = { ...template };
      this.globalService.fields_data = { ...this.template.fields_datas?.data };
      this.globalService.fields_data['blocks'] = { ...this.globalService.fields_data['blocks'] };
      const language = this.globalService.shortLangValue(this.template.language);
      this._translationsHelperService.changeLanguage(language);
      if(this.template?.template_settings?.currency){
        this.editorEmitter.setDocumentCurrency(this.template?.template_settings?.currency);
      }
      this.setActiveRecipientRole(this.currentRecipientIndex);
      this.$onlineContractFacade.addVisitedRole((this.template.recipient_roles as RecipientRole[]));
      this.templateContent = this.sanitizer.bypassSecurityTrustHtml(this.template.content);
      this._sharedStoreFacade$.saveUserTimezone(this.template?.user?.user_timezone);
      this.onlineContractLoading = false;
    });
    this.eformStepsService.activeStep$.pipe(takeUntil(this.destroyed)).subscribe((step: StepEnum) => {
      this.currentStep = step;
      if (step === StepEnum.Completed) {
        this.updateTemplateRoles();
        this.$onlineContractFacade.updateVisitedRole({...this.template_role.getRawValue(), ...{third_party_auth_response:this.third_party_auth_response, eid_reference:this.eid_reference}});
        const nextRecipientExists = this.currentRecipientIndex < (this.template.recipient_roles as RecipientRole[]).length - 1;
        const nextRoleIndex = this.currentRecipientIndex + 1;
        const nextRole = {...this.template.recipient_roles[nextRoleIndex]};
        const nextAlsoSameDeviece = nextRole.invitation_type === this.invitationThroughEnum.SAME_DEVICE;
        const isCurrentRoleViaInvitation = [this.invitationThroughEnum.EMAIL, this.invitationThroughEnum.EMAIL_AND_SMS, this.invitationThroughEnum.SMS].includes(this.roleDetail.invitation_type as InvitationThroughEnum);
        if(nextRecipientExists && this.invitationThroughEnum.SAME_DEVICE === (this.roleDetail.invitation_type as InvitationThroughEnum) && nextAlsoSameDeviece){
          timer(0, 400).pipe(take(1))
          .subscribe({
              next: () => {
                this.setActiveRecipientRole(nextRoleIndex);
                this.eformStepsService.setActiveStep(StepEnum.ActiveRoleField);
                this.third_party_auth_response = null;
                this.eid_reference = null;
                this.activeStep = 1;
              }
          });
        }else{
          if(!isCurrentRoleViaInvitation && nextRecipientExists && !nextRole?.recipient_id && !nextAlsoSameDeviece){
            timer(0, 500).pipe(take(1))
            .subscribe({
                next: () => {
                  this.handleNextRole(nextRole);
                }
            });
          } else {
            this.finishEform(nextRole);
          }
        }
      }
    });

    this.editorEmitter.deleteAttachment.pipe(takeUntil(this.destroyed)).subscribe({
      next: (attachment: DeletedAttachment) => {
        this.deletedAttachment = this.deletedAttachment.concat(attachment);
      }
    });

    this.onlineContractEventEmitterService.aysncFieldsData$.pipe(takeUntil(this.destroyed)).subscribe((field: Field) => {
      this.EForm.get('template_roles').value.forEach((role: RecipientRole, roleIndex) => {
        role?.personfields.forEach((pField, itemIndex) => {
          if (pField.id === Number(field.selected_field_type_id)) {
            if (pField.key === 'first_name') {
              const parseName = new ParseNamePipe().transform(field.value);
              const findLastName = role?.personfields.findIndex((field) => field.key === 'last_name');
              const firstNameControl = this.EForm.get(`template_roles.${roleIndex}.personfields.${itemIndex}.value`);
              const lastNameControl = this.EForm.get(`template_roles.${roleIndex}.personfields.${findLastName}.value`);
              if (firstNameControl && lastNameControl) {
                firstNameControl.patchValue(parseName.firstname);
                lastNameControl.patchValue(parseName.lastname);
              }
            } else {
              const control = this.EForm.get(`template_roles.${roleIndex}.personfields.${itemIndex}.value`);
              if (control) {
                control.patchValue(field.value);
                control.updateValueAndValidity();
              }
            }
          }
        });
        role?.orgfields.forEach((oField, itemIndex) => {
          if (oField.id === Number(field.selected_field_type_id)) {
            const control = this.EForm.get(`template_roles.${roleIndex}.orgfields.${itemIndex}.value`);
            if (control) {
              control.patchValue(field.value);
              control.updateValueAndValidity();
            }
          }
        });
      })
    });

    this.signOnlineContractRequestState.pipe(filter(status => status === HttpActionState.Done), take(1)).subscribe(() => {
        this.eformCompletedStep(this.translation, this.translationParams);
    })

    this.signOnlineContractRequestState.pipe(filter(status => status === HttpActionState.Failed), takeUntil(this.destroyed)).subscribe(() => {
      this.signOnlineContractErrorCode$.pipe(take(1)).subscribe((code) => {
        if (code === EID_NOT_COMPLETED_CODE) {
          this.restartEidAfterFailedSign();
        }
      });
    });
    
    this.criiptioBankService.getBankIdSuccess$().pipe(takeUntil(this.destroyed)).subscribe({
      next: (params) => {
        this.readyToSignTheCriiptio(params);
      }
    });
  }

  setActiveRecipientRole(index: number) {
    this.currentRecipientIndex = index;
    const role = this.template.recipient_roles[index];
    this.roleDetail = { ...role };
    this.initEformTemplate(this.template);
    this.branding_logo = this.eFormBrandingService.setLogoType(this.template?.convert_to_eform_settings?.logo_type, this.template?.branding);
    // Part of Skoogs temporary solution
    this.templateKey = this.creditSafeService.getSkoogsConfigurationType(this.template.convert_to_eform_settings.unique_id);
    this.showCreditSafe = this.shouldShowSkoogsCreditSafe(this.template.convert_to_eform_settings.unique_id);
  }

  initEformTemplate(template) {
    this.EForm = this.formBuilder.group({
      convert_to_eform_settings: this.helperService.convertToEformSettingsFormGroup(template),
      template_roles: this.formBuilder.array(this.helperService.getRoles(template?.recipient_roles.filter((_, index) => index === this.currentRecipientIndex), true, true)),
      content: [template?.content ?? ''],
      eform_message: [template?.eform_message ?? ''],
    });
    this.EForm.get('template_roles')?.valueChanges.pipe(takeUntil(this.destroyed), distinctUntilChanged(), debounceTime(500)).subscribe(() => {
      const roles: RecipientRole[] = this.EForm.getRawValue()?.template_roles;
      roles.forEach((role, roleIndex) => {
        const recipient = setRecipientData(role?.personfields);
        const organization = setOrgnizationData(role?.orgfields);
        role.personfields.forEach((field) => {
          if(field.is_enable){
            updatePersonField({ ...field }, role.recipient_id, role.id, this.globalService, "person_field", recipient);
          }
        });
        role.orgfields.forEach((orgfield) => {
          if(orgfield.is_enable){
            updateOrganizationField({ ...orgfield }, role.recipient_id, role.id, this.globalService, "org_field", true);
          }
        });
        this.roleDetail.recipient = recipient;
        const control = this.EForm.get(`template_roles.${roleIndex}.recipient`);
        const orgControl = this.EForm.get(`template_roles.${roleIndex}.organization`);
        if (control) control.patchValue(recipient, { emitEvent: false });
        if (orgControl) orgControl.patchValue(organization, { emitEvent: false });
      })
    });

    this.EForm.get('content')?.valueChanges.pipe(startWith(this.EForm.get('content')?.value), debounceTime(500), takeUntil(this.destroyed)).subscribe(() => {
      this.timeOutSubscription = of(null)
      .pipe(delay(0))
      .subscribe(() => {
        this.signingPageEvent.initEvent(this.globalService.fields_data, this.roleDetail, true);
        (this.template?.recipient_roles as RecipientRole[]).forEach((role: RecipientRole) => {
            this._refreshFileService.refreshDocumentFiles({ ...this.globalService?.fields_data }, role?.id, role?.roleable_id, true, this.template?.branding);
        });
      });
    })
  }

  /** Get form controls */
  get template_role() {
    return (this.EForm.get('template_roles') as FormArray).at(0);
  }

  validateEForm() {
    if (this.currentStep === this.stepEnum.ActiveRoleField) {
      if (this.EForm.invalid) {
        initValidationForRecipientTabs(this.EForm.controls, this.globalService);
        return false;
      }
    }
  }

  next() {
    if (this.currentStep === this.stepEnum.Completed) {
      return false;
    }
    if (this.currentStep === this.stepEnum.ActiveRoleField) {
      if (this.EForm.invalid) {
        initValidationForRecipientTabs(this.EForm.controls, this.globalService);
        return false;
      }
    } else if (this.currentStep === this.stepEnum.TemplateEditor) {
      const { status } = fieldsValidation(this.globalService.fields_data, this.globalService, String(this.roleDetail.id), false);
      const { validate } = getRoleValidationBeforeSign(this.EForm.get('template_roles') as FormArray, this.globalService, this.roleDetail.role_name);
      if (!status || validate) {
        return false;
      }
      this.confirmSignModal();
      return false;
    }
    this.processActiveStep(true);
  }

  previous() {
    if (this.currentStep === this.stepEnum.ActiveRoleField) {
      return;
    }
    this.processActiveStep();
  }

  private processActiveStep(next: boolean = false) {
    if (next) {
      this.activeStep += 1;
    } else {
      this.activeStep -= 1;
    }
    this.eformStepsService.setActiveStep(this.stepNumberEnum[`step${this.activeStep}`]);
  }

  confirmSignModal() {
    const afterSign: NgbModalRef = this.modalService.open(SignDocumentModalComponent, {
      windowClass: 'sign-document-modal',
      backdrop: 'static'
    });
    afterSign.result.then((result) => {
      if (result) {
        this.processActiveStep(true);
      }
    });
    afterSign.componentInstance.roleDetail = this.roleDetail;
    afterSign.componentInstance.isEForm = true;
    afterSign.componentInstance.document_name = this.template?.name;
    afterSign.componentInstance.recipientName = this.roleDetail.recipient.firstname + " " + (this.roleDetail.recipient?.lastname ?? "");

  }

  updateTemplateRoles() {
    const templateRoles = this.EForm.value?.template_roles;
    templateRoles.forEach((role, roleIndex) => {
      role?.personfields.forEach((item, itemIndex) => {
        if (item?.key === "phone_no" && item?.value && item?.value?.e164Number) {
          const control = this.EForm.get(`template_roles.${roleIndex}.personfields.${itemIndex}.value`);
          const landcodeControl = this.EForm.get(`template_roles.${roleIndex}.personfields.${itemIndex}.landcode`);
          if (control) {
            control.patchValue(item.value.e164Number);
            control.updateValueAndValidity();
          }
          if (landcodeControl) {
            const country = item?.value?.countryCode ? String(item.value.countryCode).toLowerCase() : null;
            landcodeControl.patchValue(country);
            landcodeControl.updateValueAndValidity();
          }
        }
      });
    });
  }

  readTermsAndCondition() {
    const termsAndConditionRef: NgbModalRef = this.modalService.open(AgreeTermsAndConditionsComponent, { size: 'lg' });
    termsAndConditionRef.componentInstance.termsAndCondition = this.EForm.get('convert_to_eform_settings').value;
    termsAndConditionRef.result.then((status: true) => {
      this.agreeTermsAndCondition = status;
    });
  }

  private validateFields() {
    const { status } = fieldsValidation(this.globalService.fields_data, this.globalService, String(this.roleDetail.id));
    if (!status) { return false }
    if (!this.roleDetail?.recipient?.persnol_no || !Personnummer.valid(this.roleDetail?.recipient?.persnol_no)) {
      this.globalService.toastrWarning(this._translocoService.translate("Toaster warning message for bankid (Signing page - section) - Person number is not valid"));
      return false;
    }
    return true;
  }

  /**
   * sign with the same device Mobile|Window
   */
  async openBankIdDeepLink() {
    if (this.globalService.isSamsungBrowser()) {
      this.modalService.open(SamsungBrowserInstructionsModalComponent);
      return;
    }
    const { validate } = getRoleValidationBeforeSign(this.EForm.get('template_roles') as FormArray, this.globalService, this.roleDetail.role_name);
    if (!this.validateFields() || validate || this.bankidLoader) {
      return false;
    }
    this.onlineContractForm.pipe(take(1)).subscribe(async (template: Template) => {
      this.bankidLoader = true;
      const { orderRef, autoStartToken } = await this.bankIdService.signBankid(template.id, this.roleDetail?.recipient?.persnol_no, template.name, template.code);
      this.orderRef = orderRef;
      await this.globalService.openBankIdApp(autoStartToken, this.isMobile, this.deviceService.getDeviceInfo().os);
      this.bankIdService.signWithBankId(this.orderRef).then((response) => {
        this.bankidLoader = false;
        this.third_party_auth_response = response.response as CollectResponseV6;
        this.eid_reference = this.orderRef;
        this.eformStepsService.setActiveStep(this.stepEnum.Completed);
      }).catch(() => this.bankidLoader = false);
    });
  }

  bankidQrCode() {
    const { validate } = getRoleValidationBeforeSign(this.EForm.get('template_roles') as FormArray, this.globalService, this.roleDetail.role_name);
    if (!this.validateFields() || validate || this.bankidLoader) {
      return false;
    }
    this.onlineContractForm.pipe(take(1)).subscribe(async (template: Template) => {
      this.bankidLoader = true;
      const bankid: NgbModalRef = this.modalService.open(BankidQrCodeModalComponent, { windowClass: 'bankid-qrcode', backdrop: 'static', keyboard: false });
      bankid.componentInstance.role_id = template.id
      bankid.componentInstance.persnol_no = this.roleDetail?.recipient?.persnol_no
      bankid.componentInstance.name = template.name
      bankid.componentInstance.unique_id = template.code
      bankid.componentInstance.apiRouteName = 'eform-bank-id';
      bankid.result.then((response: BankIdResponse) => {
        if (response.status) {
          this.third_party_auth_response = response.response as CollectResponseV6;
          this.eid_reference = response.orderRef ?? null;
          this.eformStepsService.setActiveStep(this.stepEnum.Completed);
        } else {
          this.globalService.toastrError(this._translocoService.translate("Toaster error message for bankid (Signing page - section) - Unable to sign with BankID. Please try again"));
        }
        this.bankidLoader = false;
      });
    })
  }

  /**
  * this method will work when invitation type is email, email and sms, sms
   */
  sendInvitation() {
    const { validate } = getRoleValidationBeforeSign(this.EForm.get('template_roles') as FormArray, this.globalService, this.roleDetail.role_name);
    if(validate){
      return;
    }
    this.eformStepsService.setActiveStep(this.stepEnum.Completed);
  }

  eformCompletedStep(translation: string, translateOptions) {
    this.toastr.success(this._translocoService.translate(translation, translateOptions), this._translocoService.translate("Toaster success title (Toaster title) - Success"), { timeOut: 10000 }).onHidden.pipe(take(1)).subscribe(() => {
      this.onlineContractForm.pipe(take(1)).subscribe(async (template: Template) => {
        const redirect_url = template.convert_to_eform_settings?.redirect_url;
        const redirect_url_setting = template.convert_to_eform_settings?.redirect_url_setting;
        if (redirect_url && redirect_url_setting === 1) {
          window.location.href = redirect_url;
        } else {
          window.location.reload();
        }
      })
    });
  }

  processNorwegianBankId(){
    this.criiptioBankService.authenticate(this.roleDetail, true, this.id);
  }

  processFinnishBankId(){
    this.criiptioBankService.authenticate(this.roleDetail, true, this.id);
  }

  readyToSignTheCriiptio(data){
    this.third_party_auth_response = data;
    this.eid_reference = data?.eid_reference ?? null;
    if([this.authenticationTypeEnum.DANISHMITID].includes(this.roleDetail.authentication_type)){
      this.third_party_auth_response = this.globalService.criiptoBankIDSuccess(data);
    }
    this.eformStepsService.setActiveStep(this.stepEnum.Completed);
  }

  /** TEMPORARY CREDIT SAFE PART START HERE **/

  /**
   * @todo Remove this method once generic implementation is in place.
   *
   * Check if current form should show credit safe component based on Skoogs unique ID
   * @param uniqueId - The unique ID from the form
   * @returns boolean indicating if credit safe should be shown
   */
  shouldShowSkoogsCreditSafe(uniqueId: string): boolean {
    return this.creditSafeService.isSkoogsUniqueId(uniqueId)
        && this.currentStep === this.stepEnum.ActiveRoleField
        && !this.creditSafeApproved;
  }

  onInformationNotFound(): void {
    this.toastr.error(
        "Vi kunde inte hämta uppgifterna. Kontrollera angivet person-/orgnummer eller försök igen senare",
        "Information saknas",
        {timeOut: 10000}
    );
  }

  onPersonFound(personData: any): void {
    this.isSignatorySelected = true; // forcely true the signatory selected to fill the person fields as signatory is also a recipient and we want to fill the person fields if the data is found from credit safe even the signatory is not selected in the form. once the signatory is selected in the form then also the person fields will be filled with the same data, so this will not cause any issue.
    this.fillPersonFields(personData);
  }

  onOrganizationFound(organizationData: any): void {
    this.fillOrgFields(organizationData);
    this.lockRoleFieldsUntilSignatorySelected();
  }

  onSignatorySelected(signatoryData: any): void {
    this.isSignatorySelected = true;
    this.fillPersonFields(signatoryData);
  }

  fillPersonFields(personData: any): void {
    if (!personData || !this.EForm) {
      return;
    }

    if (personData.social_security_number) {
      this.creditSafePersonalNumber = personData.social_security_number;
    }

    // Get the first role (assuming single role for EForm)
    const templateRoles = this.template_role;
    const firstRole = templateRoles;

    if (!firstRole) {
      return;
    }

    // Map person data to form fields
    const personFields = firstRole.get('personfields') as FormArray;
    const orgFields = firstRole.get('orgfields') as FormArray;

    personFields.controls.forEach((fieldControl) => {
      const field = fieldControl.value;
      const valueControl = fieldControl.get('value');
      const idControl = fieldControl.get('id');

      if (!valueControl) return;
      // only fill empty controls
      if (valueControl.value) return;

      let patched = false;

      switch (field.key) {
        case 'first_name':
          if (personData.first_name) {
            valueControl.patchValue(personData.first_name);
            patched = true;
          }
          break;
        case 'last_name':
          if (personData.last_name) {
            valueControl.patchValue(personData.last_name);
            patched = true;
          }
          break;
        case 'personal_id_number':
          if (personData.social_security_number) {
            valueControl.patchValue(personData.social_security_number);
            patched = true;
          }
          break;
        case 'address':
          if (personData.address) {
            valueControl.patchValue(personData.address);
            patched = true;
          }
          break;
        case 'zip_code':
          if (personData.zip) {
            valueControl.patchValue(personData.zip);
            patched = true;
          }
          break;
        case 'city':
          if (personData.city) {
            valueControl.patchValue(personData.city);
            patched = true;
          }
          break;
        case 'email':
          if (personData.email) {
            valueControl.patchValue(personData.email);
            patched = true;
          }
          break;
        case 'phone_no':
          if (personData.phone) {
            valueControl.patchValue(personData.phone);
            patched = true;
          }
          break;
      }

      if (patched) {
        // disable the control in the form so the user cannot change it immediately
        try {
          valueControl.disable({ emitEvent: false });
          this.disabledTheDragField(idControl, "person_field");
        } catch (e) {
          // fallback if control doesn't support disable for some reason
        }

        valueControl.updateValueAndValidity({ emitEvent: false });
      } else {
        // enable the control in the form so the user can change it immediately
        try {
          valueControl.enable({ emitEvent: false });
        } catch (e) {
          // fallback if control doesn't support disable for some reason
        }

        valueControl.updateValueAndValidity({ emitEvent: false });
      }
    });

    // Fill any organization fields if any (people can also have org fields)
    orgFields.controls.forEach((fieldControl) => {
      const field = fieldControl.value;
      const valueControl = fieldControl.get('value');
      const idControl = fieldControl.get('id');

      if (!valueControl) return;
      if (valueControl.value) return;

      let patched = false;

      switch (field.key) {
        case 'organization':
          if (personData.full_name) {
            valueControl.patchValue(`${personData.full_name}`);
            patched = true;
          }
          break;
        case 'reg_no':
          if (personData.social_security_number) {
            valueControl.patchValue(`${personData.social_security_number}`);
            patched = true;
          }
          break;
        case 'address':
          if (personData.address) {
            valueControl.patchValue(personData.address);
            patched = true;
          }
          break;
        case 'zip_code':
          if (personData.zip) {
            valueControl.patchValue(personData.zip);
            patched = true;
          }
          break;
        case 'city':
          if (personData.city) {
            valueControl.patchValue(personData.city);
            patched = true;
          }
          break;
      }

      if (patched) {
        try {
          valueControl.disable({ emitEvent: false });
          this.disabledTheDragField(idControl, "org_field");
        } catch (e) {
          // fallback if control doesn't support disable for some reason
        }
        valueControl.updateValueAndValidity({ emitEvent: false });
      }
    });

    // Trigger form validation and updates
    firstRole.updateValueAndValidity();
  }

  fillOrgFields(organizationData: any): void {
    if (!organizationData || !this.EForm) {
      return;
    }

    if (organizationData.orgno) {
      this.creditSafeOrganizationNumber = organizationData.orgno;
    }

    // Get the first role (assuming single role for EForm)
    const templateRoles = this.template_role;
    const firstRole = templateRoles;

    if (!firstRole) {
      return;
    }

    // Map organization data to form fields
    const orgFields = firstRole.get('orgfields') as FormArray;

    orgFields.controls.forEach((fieldControl) => {
      const field = fieldControl.value;
      const valueControl = fieldControl.get('value');
      const idControl = fieldControl.get('id');

      if (!valueControl) return;
      if (valueControl.value) return;

      let patched = false;

      switch (field.key) {
        case 'organization':
          if (organizationData.company_name) {
            valueControl.patchValue(organizationData.company_name);
            patched = true;
          }
          break;
        case 'reg_no':
          if (organizationData.orgno) {
            valueControl.patchValue(organizationData.orgno);
            patched = true;
          }
          break;
        case 'phone_no':
          if (organizationData.company_telephone && organizationData.company_telephone.length > 0) {
            valueControl.patchValue(organizationData.company_telephone[0]);
            patched = true;
          }
          break;
        case 'address':
          if (organizationData.address) {
            valueControl.patchValue(organizationData.address);
            patched = true;
          }
          break;
        case 'zip_code':
          if (organizationData.zip) {
            valueControl.patchValue(organizationData.zip);
            patched = true;
          }
          break;
        case 'city':
          if (organizationData.city) {
            valueControl.patchValue(organizationData.city);
            patched = true;
          }
          break;
        case 'företagets_e-post':
          if (organizationData.company_email && organizationData.company_email.length > 0) {
            valueControl.patchValue(organizationData.company_email[0]);
            patched = true;
          }
          break;
      }

      if (patched) {
        try {
          valueControl.disable({ emitEvent: false });
          this.disabledTheDragField(idControl, "org_field");
        } catch (e) {
          // fallback if control doesn't support disable for some reason
        }
        valueControl.updateValueAndValidity({ emitEvent: false });
      }
    });

    // Trigger form validation and updates
    firstRole.updateValueAndValidity();
  }

  onCreditRatingApproved(): void {
    this.creditSafeApproved = true;
    this.showCreditSafe = false;
    this.next();
  }

  onCreditRatingRejected(): void {
    this.previous();
  }

  onCreditCheckRequestFailed(): void {
    this.previous();
  }

  private lockRoleFieldsUntilSignatorySelected(): void {
    const firstRole = this.template_role as FormGroup;
    if (!firstRole) {
      return;
    }
    const controlsToLock = this.getRoleValueControls(firstRole);
    controlsToLock.forEach((control: AbstractControl) => {
      if (control?.enabled) {
        control.disable({ emitEvent: false });
      }
    });

    firstRole.updateValueAndValidity({ emitEvent: false });
  }

  private getRoleValueControls(role: FormGroup): AbstractControl[] {
    const personFields = role.get('personfields') as FormArray;
    const controls: AbstractControl[] = [];

    personFields?.controls?.forEach((fieldControl: AbstractControl) => {
      const valueControl = fieldControl.get('value');
      if (valueControl) controls.push(valueControl);
    });

    return controls;
  }

  private disabledTheDragField(idControl: AbstractControl, field_section: string): void {
    const existingField = this.globalService.findMatchingField(this.globalService.fields_data, 'selected_field_type_id', idControl.value, field_section);
    existingField.forEach((field:Field) => {
      const dragField = document.querySelector('.drag-fields[uuid="' + field.uuid + '"]') as HTMLElement;
      if (dragField) {
          this.renderer.addClass(dragField, 'pointer-none');
      }
    })
  }
  /** TEMPORARY CREDIT SAFE PART END HERE **/

  addRecipient(role:RecipientRole) {
    const recipientRef: NgbModalRef = this.modalService.open(RecipientModalComponent, {
        backdrop: 'static',
        windowClass: 'edit-recipient-modal'
    });
    recipientRef.componentInstance._recipientRole = role;
    recipientRef.componentInstance._updateRecipient = false;
    recipientRef.componentInstance._navigation = 'recipient';
    recipientRef.componentInstance._activeIndex = 0;
    recipientRef.componentInstance.isEditParticipientFromSigningPage = true;
    recipientRef.componentInstance.isSendForSignature = true;
    return recipientRef.result;
  }

  private handleNextRole(nextRole: RecipientRole): void {
    this.addRecipient(nextRole).then((result) => {
      if (result) {
        this.populateRoleWithRecipientData(nextRole, result);
      }
    });
  }

  private populateRoleWithRecipientData(role: RecipientRole, data): void {
    role.recipient = data?.recipient;
    role.organization = data?.organization;
    role.personfields = data?.personfields;
    role.orgfields = data?.orgfields;
    role.third_party_auth_response = null;
    role.eid_reference = null;
    this.$onlineContractFacade.updateVisitedRole(role);
    this.finishEform(role);
  }

  // The backend refused an eID result as missing, expired or already used, so send the signer back to identify again.
  private restartEidAfterFailedSign(): void {
    if (this.currentStep !== StepEnum.Completed) {
      return;
    }
    this.visitedRoles$.pipe(take(1)).subscribe((visitedRoles) => {
      const eidRoles = visitedRoles.filter(visited => visited.eid_reference);
      const roleIndex = (this.template.recipient_roles as RecipientRole[]).findIndex(templateRole => eidRoles.some(visited => visited.id === templateRole.id));
      if (roleIndex === -1) {
        return;
      }
      const resetRoles = visitedRoles.map(visited => (visited.eid_reference ? { ...visited, third_party_auth_response: null, eid_reference: null } : visited));
      resetRoles.filter(visited => eidRoles.some(eidRole => eidRole.id === visited.id)).forEach(visited => this.$onlineContractFacade.updateVisitedRole(visited));
      // Rebuild each role's form from what the signer already entered, not from the blank template role.
      this.template = {
        ...this.template,
        recipient_roles: (this.template.recipient_roles as RecipientRole[]).map(templateRole => ({ ...templateRole, ...resetRoles.find(visited => visited.id === templateRole.id) })),
      };
      this.third_party_auth_response = null;
      this.eid_reference = null;
      this.activeStep = 1;
      this.setActiveRecipientRole(roleIndex);
      this.eformStepsService.setActiveStep(StepEnum.ActiveRoleField);
    });
  }

  private finishEform(role:RecipientRole): void {
    this.setToastMessage(role);
    this.visitedRoles$.pipe(take(1)).subscribe((visitedRoles) => {
        const signData = {
          all_fields_data: { ...this.globalService.fields_data },
          recipient_roles: visitedRoles,
          third_party_auth_response: this.third_party_auth_response,
          deleted_attachments: this.deletedAttachment,
          uuid: this.externalSender
        }
       this.$onlineContractFacade.signOnlineContract(signData, Number(this.id));
    });
  }

  private setToastMessage(role: RecipientRole) {
    const invitationTypePipe = new InvitationTypePipe();
    const nextRecipientExists = (this.template.recipient_roles as RecipientRole[]).length;
    if(nextRecipientExists > 1){
      if([this.invitationThroughEnum.EMAIL, this.invitationThroughEnum.EMAIL_AND_SMS, this.invitationThroughEnum.SMS].includes(this.roleDetail.invitation_type as InvitationThroughEnum)){
        if(!this.roleDetail.recipient_id){
          this.translation = "Toaster success message for online contract sign (EForm - section) - Rolename has been invited to signaturemethod before the process is completed";
          this.translationParams = { rolename: this.roleDetail.role_name, signaturemethod: invitationTypePipe.transform(this.roleDetail.invitation_type, true) };
        }else if(this.roleDetail?.recipient_id){
          this.translation = "Toaster success message for online contract sign (EForm - section) - Name has been invited to signaturemethod before the process is completed";
          this.translationParams = { name: `${this.roleDetail?.recipient?.firstname} ${this.roleDetail?.recipient?.lastname}` , signaturemethod: invitationTypePipe.transform(this.roleDetail.invitation_type, true) };
        }
      }else if(this.roleDetail.invitation_type === this.invitationThroughEnum.SAME_DEVICE){
        if([this.invitationThroughEnum.EMAIL, this.invitationThroughEnum.EMAIL_AND_SMS, this.invitationThroughEnum.SMS].includes(role.invitation_type as InvitationThroughEnum)){
          if(!role.recipient_id){
            this.translation = "Toaster success message for online contract sign (EForm - section) - Rolename has been invited to signaturemethod before the process is completed";
            this.translationParams = { rolename: role.role_name, signaturemethod: invitationTypePipe.transform(role.invitation_type, true) };
          }else if(role?.recipient_id){
            this.translation = "Toaster success message for online contract sign (EForm - section) - Name has been invited to signaturemethod before the process is completed";
            this.translationParams = { name: `${role?.recipient?.firstname} ${role?.recipient?.lastname}` , signaturemethod: invitationTypePipe.transform(role.invitation_type, true) };
          }
        }else{
          this.translation = "Toaster success message for online contract sign (EForm - section) - The template has been signed successfully";
          this.translationParams = { template: this.template.name };
        }
      }
    }else{
      if([this.invitationThroughEnum.EMAIL, this.invitationThroughEnum.EMAIL_AND_SMS, this.invitationThroughEnum.SMS].includes(this.roleDetail.invitation_type as InvitationThroughEnum)){
        this.translation = "Toaster success message for online contract sign (EForm - section) - Invitation was sent to name";
        this.translationParams = { name: `${this.roleDetail?.recipient?.firstname} ${this.roleDetail?.recipient?.lastname}` };
      }else{
        this.translation = "Toaster success message for online contract sign (EForm - section) - The template has been signed successfully";
        this.translationParams = { template: this.template.name };
      }
    }
  }

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
    if (this.timeOutSubscription) {
      this.timeOutSubscription.unsubscribe();
    }
  }
}
